import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { showError } from '../../constants/toasts';
import FeedbackReview from '../../features/dashboard/feedbackReview';
import GoogleRating from '../../features/dashboard/GoogleRating';
import usePermission from '../../hooks/usePermission';
import MainContainer from '../../layout/MainContainer';
import { DashboardResponse, useLazyDashboardDataQuery } from '../../service/dashboard';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#204e33' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Dashboard = () => {
  const navigate = useNavigate();
  const [dashboard] = useLazyDashboardDataQuery();
  const [dashboardData, setDashboardData] = useState<DashboardResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getDashboardData = async () => {
    setIsLoading(true);

    try {
      const res = await dashboard().unwrap();
      if (res?.statusCode === 200) {
        setDashboardData(res?.data || {});
      } else {
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      // setDashboardData({})
    }
    setIsLoading(false);
    // ref?.current?.complete();
  };

  const { isAdd, isDelete } = usePermission({
    label: 'Dashboard',
    page_permission: 'isView',
  });
  const graphOrderData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Individuals',
        data: ['10', '20', '25', '15', '50', '10', '20', '25', '15', '50', '20', '25'],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };
  const graphDealerData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Dealers',
        data: ['10', '20', '25', '15', '50', '10', '20', '25', '15', '50', '20', '25'],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };
  const graphStoreData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Stores',
        data: ['10', '20', '25', '15', '50', '10', '20', '25', '15', '50', '20', '25'],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };
  const graphPostsData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Posts',
        data: ['10', '20', '25', '15', '50', '10', '20', '25', '15', '50', '20', '25'],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>
      <div className="stats_boxes gap_m">
        <div
          className="cards"
          // onClick={() => navigate("/dashboard/uninstalled-users")}
        >
          <figure>
            <img
              src="/static/images/add-friend.png"
              alt=""
              style={{ height: '30px', width: '30px' }}
            />
          </figure>
          <h2>{dashboardData?.individualCount || '-'}</h2>
          <p>Total number of registered individuals</p>
        </div>
        <div
          className="cards"
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <figure>
            <img
              src="/static/images/dealing.png"
              alt=""
              style={{ height: '30px', width: '30px' }}
            />
          </figure>
          <h2>{dashboardData?.dealerCount || '-'}</h2>
          <p>Total number of registered dealers</p>
        </div>
        {/* <div
          className="cards"
          // onClick={() => navigate("/dashboard/unregistered-users")}
        >
          <figure>
            <img src="/static/images/download_icon.svg" alt="" />
          </figure>
          <h2>13K</h2>
          <p>Total number of registered stores</p>
        </div> */}
        <div
          className="cards"
          // onClick={() => navigate("/dashboard/downloaded-users")}
        >
          <figure>
            <img
              src="/static/images/listing.png"
              alt=""
              style={{ height: '30px', width: '30px' }}
            />
          </figure>
          <h2>{dashboardData?.addsCount || '-'}</h2>
          <p>Total number of ads</p>
        </div>
        <div
          className="cards"
          // onClick={() => navigate("/dashboard/downloaded-users")}
        >
          <figure>
            <img src="/static/images/growth.png" alt="" style={{ height: '30px', width: '30px' }} />
          </figure>
          <h2>AED 100</h2>
          <p>Total revenue</p>
        </div>
      </div>
      <div className="grid_sc gap_m ">
        {/* <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Total Individuals</h2>
          <LineChart data={graphOrderData} />
        </Item>
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Total Dealers</h2>
          <LineChart data={graphDealerData} />
        </Item>
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Total Stores</h2>
          <LineChart data={graphStoreData} />
        </Item>
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Total Posts</h2>
          <LineChart data={graphPostsData} />
        </Item> */}
        <FeedbackReview />

        <GoogleRating />
        {/* <SelectDuration /> */}
        {/* <TravelersQuestionnaire />
        <CustomersQuestionnaires /> */}
      </div>
    </MainContainer>
  );
};

export default Dashboard;
